import React from 'react';
import { Button, Input, Label, Row, Col } from 'reactstrap';
import api from '../../api';
import './index.css';

export default class TrafficScanningLog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scanningLog: this.props.scanningLog,
      isCounting: false,
    };
  }
  componentDidMount() {
    
  }
  changeLoggingStatus(actionName) {
    const { scanningLog } = this.props;
    
    if (actionName === 'count') {
      this.setState({ isCounting: true });
    }

    api.fetchAPI({
      method: 'post',
      uri: `traffic_scanning_log/${scanningLog.id}/${actionName}`,
      success: (response) => {
          if (response.status == 'ok') {
            scanningLog.status = response.result.status;
            scanningLog.from_date = response.result.from_date;
            scanningLog.to_date = response.result.to_date;
            scanningLog.distinct_mac_address_count = response.result.distinct_mac_address_count;
            this.setState({
              scanningLog,
            });

            if (actionName === 'count') {
              this.setState({ isCounting: false });
            }
          } else {
            alert(response.msg);
          }
      },
    });
  }
  render() {
    const { scanningLog, isCounting } = this.state;
    if (!scanningLog) return null;
    return (
      <div className="location-scanning-log">
          <div className="location-scanning-log__info">
            <div className="location-scanning-log__top-info">
              <p className="location-scanning-log__name">{scanningLog.name}</p>
              <span className={`location-scanning-log__status ${scanningLog.status}`}>{scanningLog.status}</span>
            </div>
            <p>Start time: {scanningLog.from_date}</p>
            <p>End time: {scanningLog.to_date}</p>
            <p className="location-scanning-log__mac-address--count">MAC Address count: {scanningLog.distinct_mac_address_count}</p>
          </div>
          <div className="location-scanning-log__actions">
            {scanningLog.status === 'not_started' &&
              <Button
                color="info"
                onClick={() => this.changeLoggingStatus('start')}
              >
                Start
              </Button>
            }
            {scanningLog.status === 'started' &&
              <Button
                color="danger"
                onClick={() => this.changeLoggingStatus('stop')}
              >
                Stop
              </Button>
            }
            {scanningLog.status === 'complete' &&
              <Button
                color={isCounting ? "secondary" : "success"}
                onClick={() => this.changeLoggingStatus('count')}
                disabled={isCounting}
              >
                {isCounting ? 'Counting...' : 'Count traffic'}
              </Button>
            }
          </div>
      </div>
    );
  }
}